<template>
  <div class="rf-final-part mt-3">
    <b-form-group
      label="Lista de excepciones a la política"
      label-for="fe-flagged-comments"
      description="Comentarios"
      class="mb-3"
    >
      <b-form-textarea
        id="fe-flagged-comments"
        :value="model.flagged_comments"
        @input="update('flagged_comments', $event)"
        :disabled="effectiveDisabled"
        rows="2"
        max-rows="4"
        :maxlength="MAX_LEN"
        placeholder=""
      />
      <small class="text-muted d-block mt-1">
        {{ (model.flagged_comments || '').length }}/{{ MAX_LEN }}
      </small>
    </b-form-group>

    <h5 class="mb-3">Conclusión</h5>

    <b-form-group
      label="Calificación de riesgo residual revisado (el resultado final se determina con base al estándar de seguridad más la justificación de quien realiza la evaluación en sitio)"
      label-for="fe-reviewed-residual-risk"
      description="Calificación de riesgo residual revisado (1–5). Revisar hallazgos y confirmar si afectan la calificación global. Si aplica, proporcione calificación revisada."
      class="mb-3"
    >
      <b-form-select
        id="fe-reviewed-residual-risk"
        :options="riskOptions"
        :value="model.reviewed_residual_risk"
        @input="onSelectRisk"
        :disabled="effectiveDisabled"
      />
    </b-form-group>

    <b-form-group
      label="Resumen Ejecutivo del Análisis de Riesgo"
      label-for="fe-executive-resume"
      description="Proporcionar una descripción para justificar la calificación de riesgo residual."
      class="mb-1"
    >
      <b-form-textarea
        id="fe-executive-resume"
        :value="model.executive_resume"
        @input="update('executive_resume', $event)"
        :disabled="effectiveDisabled"
        rows="2"
        max-rows="4"
        :maxlength="MAX_LEN"
        placeholder="…"
      />
      <small class="text-muted d-block mt-1">
        {{ (model.executive_resume || '').length }}/{{ MAX_LEN }}
      </small>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "RiskEvaluationFinalPart",
  props: {
    value: {
      type: Object,
      default: () => ({
        flagged_comments: "",
        // Backend can be inconsistent with this key name.
        grade_reviwed_residual_risk: null,
        grade_review_residual_risk: null,
        reviewed_residual_risk: null,
        executive_resume: "",
      }),
    },
    disabled: { type: Boolean, default: false },
    canEdit: { type: Boolean, default: true },
  },
  data() {
    return {
      MAX_LEN: 255,
      model: {
        flagged_comments: "",
        reviewed_residual_risk: null,
        executive_resume: "",
      },
      riskOptions: [
        { value: null, text: "Seleccionar calificación" },
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
        { value: 5, text: "5" },
      ],
    };
  },
  computed: {
    effectiveDisabled() {
      return !!this.disabled || !this.canEdit;
    },
  },
  created() {
    this.model = this.normalize(this.value);
  },
  watch: {
    value: {
      deep: true,
      handler(next) {
        this.model = this.normalize(next);
      },
    },
  },
  methods: {
    normalize(obj = {}) {
      // Accept multiple backend keys and normalize into a single UI field.
      const raw =
        obj.grade_review_residual_risk != null
          ? obj.grade_review_residual_risk
          : obj.grade_reviwed_residual_risk != null
          ? obj.grade_reviwed_residual_risk
          : obj.reviewed_residual_risk;

      const parsed = raw == null ? null : Number(raw);
      const reviewedResidualRisk =
        parsed == null || Number.isNaN(parsed) ? null : parsed;

      return {
        flagged_comments: obj.flagged_comments ?? "",
        reviewed_residual_risk: reviewedResidualRisk,
        executive_resume: obj.executive_resume ?? "",
      };
    },

    update(key, val) {
      if (this.effectiveDisabled) return;

      const next = { ...this.model, [key]: val };

      if (key === "flagged_comments" && typeof val === "string" && val.length > this.MAX_LEN) {
        next.flagged_comments = val.slice(0, this.MAX_LEN);
      }

      if (key === "executive_resume" && typeof val === "string" && val.length > this.MAX_LEN) {
        next.executive_resume = val.slice(0, this.MAX_LEN);
      }

      this.model = next;
      this.emitUpdate(next);
    },

    onSelectRisk(val) {
      if (this.effectiveDisabled) return;

      const parsed = val === "" || val == null ? null : Number(val);
      const clean = Number.isNaN(parsed) ? null : parsed;
      this.update("reviewed_residual_risk", clean);
    },

    emitUpdate(m) {
      const reviewedValue = m.reviewed_residual_risk ?? null;

      const payload = {
        flagged_comments: m.flagged_comments ?? "",
        executive_resume: m.executive_resume ?? "",
        reviewed_residual_risk: reviewedValue,
        grade_review_residual_risk: reviewedValue,
        grade_reviwed_residual_risk: reviewedValue,
      };

      this.$emit("input", payload);
      this.$emit("update:value", payload);
    },
  },
};
</script>
